import { EnvironmentProviders } from '@angular/core';
import { SidenavState } from '@app/core/sidenav/store/sidenav.state';
import { provideStates } from '@ngxs/store';

export function provideSidenav(): EnvironmentProviders {
  return provideStates([SidenavState]);
}
